module.exports = "/_next/static/images/1a8bb4a2c1cc3de5e5605603fe4324b2-graphic-icon.svg.webp";